import React from "react";

export default function BellOutlined({ width = "20px", height = "20px" }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5 13.5938H12.0312V6.95312C12.0312 4.19727 9.99414 1.91992 7.34375 1.54102V0.78125C7.34375 0.349609 6.99414 0 6.5625 0C6.13086 0 5.78125 0.349609 5.78125 0.78125V1.54102C3.13086 1.91992 1.09375 4.19727 1.09375 6.95312V13.5938H0.625C0.279297 13.5938 0 13.873 0 14.2188V14.8438C0 14.9297 0.0703125 15 0.15625 15H4.375C4.375 16.207 5.35547 17.1875 6.5625 17.1875C7.76953 17.1875 8.75 16.207 8.75 15H12.9688C13.0547 15 13.125 14.9297 13.125 14.8438V14.2188C13.125 13.873 12.8457 13.5938 12.5 13.5938ZM6.5625 15.9375C6.04492 15.9375 5.625 15.5176 5.625 15H7.5C7.5 15.5176 7.08008 15.9375 6.5625 15.9375ZM2.5 13.5938V6.95312C2.5 5.86719 2.92188 4.84766 3.68945 4.08008C4.45703 3.3125 5.47656 2.89062 6.5625 2.89062C7.64844 2.89062 8.66797 3.3125 9.43555 4.08008C10.2031 4.84766 10.625 5.86719 10.625 6.95312V13.5938H2.5Z"
        fill="currentColor"
      />
    </svg>
  );
}
